import Axios from 'axios'
import { SERVER_BASE_URL } from '../baseUrl'
export const getAvisByUserNew = async (token: string, userId: string) => {
  try {
    const response = await Axios.get(`${SERVER_BASE_URL}api/avis/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}
